<template>
  <div class="protocol login-protocol">
    <navigation>《用户授权协议》</navigation> 
    <section class="content">
      <p class="text tab-2">
        《用户授权协议》（以下简称“本协议”）是重庆市崇天小额贷款有限公司（以下简称“天美贷”）与用户（以下简称“您”）所订立的有效合约。您通过网络页面点击确认或以其他方式选择接受本协议，视为您与天美贷已达成协议并同意接受本协议的全部约定内容。
      </p>
      <p class="text tab-2">
        您即将通过本登陆页面使用天美贷平台账户授权登录第三方站点或软件。
      </p>
      <p class="text tab-2">
        在接受本协议之前，请您仔细阅读本协议的全部内容。如您不同意本协议内容，或无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。
      </p>
      <p class="text tab-2">
        您授权天美贷将您天美贷平台账户的相关信息和数据传递给第三方，用于第三方向您提供服务。页面提示上会展示具体授权对象、授权字段及内容等，授权字段将通过加密通道传递给第三方。天美贷会要求第三方依法使用您的上述信息，并应对您的信息保密。如您不希望向第三方提供上述信息，请勿点击“登录”或“确认”。
      </p>
      <p class="text tab-2">
        您理解，第三方服务由相应第三方提供并就以上服务及数据安全独立承担全部责任。因该第三方服务或其使用您的信息产生的纠纷，或第三方服务违反相关法律法规，或您在使用第三方服务过程中遭受的损失，请您和第三方协商解决。
      </p>
      <p class="text tab-2">
        网络欺诈往往会模仿、仿冒本登录页面的样式制作视觉感相似的页面，引诱用户输入账号和密码等信息。天美贷提醒您防范网络风险，不要向非天美贷的站点或任何人士透露您的天美贷账号、密码等相关信息。
      </p>
      <p class="text tab-2">
        您同意，天美贷有权不时修改本协议，并将协议变更情况在天美贷平台的网站上公示，该等变更自公告载明的生效时间起生效，并成为本协议的一部分。
      </p>
      <p class="text tab-2">
        本协议未尽事宜，参照
        <router-link to="/tmd/protocol/login">《天美贷平台用户注册协议》</router-link>
        及《
        <a @click="routerToProtocol('/tmd/protocol/privacy')" >《天美贷个人信息保护政策》</a>
        执行；
        <router-link to="/tmd/protocol/login">《天美贷平台用户注册协议》</router-link>
        或
        <a @click="routerToProtocol('/tmd/protocol/privacy')" >《天美贷个人信息保护政策》</a>
        与本协议有冲突的，以本协议为准。

        
      </p>
      <br/>
      <br/>
    </section>
  </div>
</template>

<script>

export default {
  name: 'authProtocol',
  created () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;
        
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
